'use strict';

var cov_29nrk5tzr2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/fab/fab.js',
        hash = '9d49e770f8444ab1f1218545586f95ba225209b8',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/fab/fab.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_29nrk5tzr2.s[0]++;
angular.module('app').component('fab', {
    templateUrl: 'app/components/fab/fab.html',
    bindings: {
        onAction: '&',
        tooltip: '@',
        icon: '@'
    }
});